(function () {
  var nav = document.getElementById('header-nav');
  var toggle = document.querySelector('[data-menu-toggle]');
  var backdrop = document.querySelector('.nav-backdrop');
  function setMenu(open) {
    if (!nav || !toggle) return;
    nav.classList.toggle('is-open', open);
    if (backdrop) backdrop.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  if (toggle && nav) {
    toggle.addEventListener('click', function () { setMenu(!nav.classList.contains('is-open')); });
    document.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
  }

  var variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      var available = opt.dataset.available === 'true';
      document.querySelectorAll('[data-product-price], [data-product-price-bar]').forEach(function (el) {
        if (opt.dataset.price) el.textContent = opt.dataset.price;
      });
      document.querySelectorAll('[data-add-button], [data-add-button-bar]').forEach(function (b) {
        b.disabled = !available;
        b.textContent = available ? 'In winkelwagen' : 'Uitverkocht';
      });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variantSelect.value);
      window.history.replaceState({}, '', url.toString());
    });
  }

  var revealTargets = document.querySelectorAll('.section-title, .step, .card, .tile, .duo__card, .review, .fact, .usp, .about__text');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealTargets.forEach(function (el, i) {
      el.classList.add('reveal');
      el.style.transitionDelay = ((i % 4) * 80) + 'ms';
      io.observe(el);
    });
  }

  var slides = document.querySelector('[data-pdp-slides]');
  if (slides) {
    var dots = document.querySelectorAll('.pdp__dot');
    var thumbs = document.querySelectorAll('[data-pdp-thumb]');
    function mark(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    slides.addEventListener('scroll', function () {
      mark(Math.round(slides.scrollLeft / slides.clientWidth));
    }, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.dataset.pdpThumb, 10);
        slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
        mark(i);
      });
    });
  }
})();
